import {
	FieldLayout,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface ICPPSetupFieldsPanel { selectedTaxYear: number | null }
export const CPPSetupFieldsPanel: FC<ICPPSetupFieldsPanel> = ({ selectedTaxYear }) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				label="Annual Max Pensionable Earnings"
				id="annualMaxPensionableEarnings"
				testId={`annual-Max-Pensionable-Earnings`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}

			/>
			<RHookFormNumberFieldWithLabel
				label="Basic Exemption for the year"
				id="basicExemptionForTheYear"
				testId={`Basic-Exemption-for-the-year`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}

			/>
			<RHookFormNumberFieldWithLabel
				id={"employeeContributionRate"}
				label="Employee Contribution Rate"
				testId="Employee-Contribution-Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}

			/>
			<RHookFormNumberFieldWithLabel
				id={"employerContributionRate"}
				label="Employer Contribution Rate"
				testId="Employer-Contribution-Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"employeeMaxContribution"}
				label="Employee Max. Contribution"
				testId="employee-Max-Contribution"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			{selectedTaxYear !== null && selectedTaxYear >= 2024 && <RHookFormNumberFieldWithLabel
				id={"annualSecondCppMaxPensionableEarnings"}
				label="Annual Second Cpp Max Pensionable Earnings"
				testId="annual-Max-Pensionable-Earnings"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>}
			{selectedTaxYear !== null && selectedTaxYear >= 2024 && <RHookFormNumberFieldWithLabel
				id={"secondCppContributionRate"}
				label="Second Cpp Contribution Rate"
				testId="second-Cpp-Contribution-Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>}
			{selectedTaxYear !== null && selectedTaxYear >= 2024 && <RHookFormNumberFieldWithLabel
				id={"secondCppMaxContribution"}
				label="Second Cpp Max Contribution"
				testId="second-Cpp-Max-Contribution"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>}
			<RHookFormNumberFieldWithLabel
				id={"cpp_qpp_k2_variable"}
				label="K2 Variable"
				testId="cpp_qpp_k2_variable"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
